
module.exports = {
	SET_CURRRENT_RESPONSE: "SET_CURRRENT_RESPONSE",
	CLEAR_CURRRENT_RESPONSE: "CLEAR_CURRRENT_RESPONSE",
	REPLACE_CURRRENT_RESPONSE: "REPLACE_CURRRENT_RESPONSE",
	SUBMIT_RESPONSE: "SUBMIT_RESPONSE",
	SUBMISSION_REQUEST: "SUBMISSION_REQUEST",
	SUBMISSION_SUCCESS: "SUBMISSION_SUCCESS",
	SUBMISSION_ERROR: "SUBMISSION_ERROR",
	SET_RESPONSE_VALIDATION_ERROR: "SET_RESPONSE_VALIDATION_ERROR",
	CLEAR_RESPONSE_VALIDATION_ERROR: "CLEAR_RESPONSE_VALIDATION_ERROR"
};



// WEBPACK FOOTER //
// ./src/common/modules/responses/constants.js